import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { name } = rowData;
        return (
          <span className="tootop-teste" title={name}>
            {name}
          </span>
        );
      },
    },
    { title: t('general.start_time'), field: 'startTime' },
    { title: t('general.end_time'), field: 'finalTime' },
    {
      title: t('placeholder.shift.consolidationDiaryHour'),
      field: 'consolidationTime',
    },
    { title: t('general.classes'), field: 'classQuantity' },
    { title: t('general.active'), field: 'activeDescription' },
  ];
}
